import { Title, Text, Button } from '@mantine/core';
import classes from './Welcome.module.css';
import { useNavigate } from 'react-router-dom';

export function Welcome() {

  const navigate = useNavigate();

  return (
    <>
      <Title className={classes.title} ta="center" mt={100}>
        Welcome to{' '}
        <Text inherit variant="gradient" component="span" gradient={{ from: 'pink', to: 'yellow' }}>
          3D Map
        </Text>
      </Title>
      <Text c="dimmed" ta="center" size="lg" maw={580} mx="auto" mt="xl">
        <Button onClick={() => navigate('/map')}>View Map</Button>
      </Text>
    </>
  );
}
